import { resetRequestState } from "../../utils/resetRequestState";
import { State } from "./types";

function handleEditEvent(state: State): State {
  return state.map((result) => ({
    ...result,
    request: resetRequestState(),
  }));
}

export { handleEditEvent };
